<template>
  <div v-if="!connected" class="w-100 position-fixed fixed-top bg-danger text-white text-center">
    <p class="mb-0 px-1"><b>Sem conexão com a internet!</b></p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      connected: true
    }
  },
  methods: {
    checkConnection: function () {
      setInterval( () => {
        this.connected = navigator.onLine
      }, 4000)
    }
  },
  mounted () {
    this.checkConnection()
  }
}
</script>

<style>

</style>
